<div class="form-setup-body" [attr.questionId]="question?.id" [ngClass]="{ 'groups-available': groupsSelectItems?.length > 0 }">
    <div class="ion-padding" class="form-setup-top-content">
        <ion-list mode="ios" lines="full">
            <ion-row llrm>
                <ion-col size="12">
                    <ion-item class="order" lines="none">
                        <!-- <ion-label position="stacked">{{ 'manageVersion.questionTitle' | translate }} *</ion-label> -->
                        <ion-icon
                            slot="start"
                            (click)="toggleExpand()"
                            color="medium"
                            class="expand"
                            [ngClass]="{ 'bp-arrow-top': question.expanded, 'bp-arrow-bottom': !question.expanded }"
                        >
                        </ion-icon>
                        <ion-label style="white-space: nowrap">
                            {{ question.globalizationConfig[language].title }}
                        </ion-label>
                        <!-- <ion-input type="text"
                          [placeholder]="'manageVersion.questionTitle' | translate"
                          [(ngModel)]="question.globalizationConfig[ language ].title">
                        </ion-input> -->
                        <div slot="end">
                            <div *ngIf="hasAttributesConfig" (click)="manageAttributes()" class="manage-attributes">
                                <span> {{ question.attributes?.length }} {{ "Atributo(s)" | translate | uppercase }} </span>
                                <ion-icon class="bp-setting" name="settingsCog"></ion-icon>
                            </div>
                            <div class="lang-selection">
                                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('pt-BR')" [ngClass]="{ active: language === 'pt-BR' }">
                                    PT
                                </ion-button>
                                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('en-US')" [ngClass]="{ active: language === 'en-US' }">
                                    EN
                                </ion-button>
                                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('es-ES')" [ngClass]="{ active: language === 'es-ES' }">
                                    ES
                                </ion-button>
                            </div>
                            <ion-button mode="ios" fill="clear" color="danger" (click)="confirmDeleteQuestion(question.guid)">
                                <ion-icon class="bp-delete" name="delete"></ion-icon>
                            </ion-button>

                            <ion-button mode="ios" fill="clear" color="primary">
                                {{ "manageVersion.order" | translate | uppercase }}
                            </ion-button>
                            <ion-row style="width: 40px" class="count-control">
                                <ion-col size="12">
                                    <ion-button mode="ios" (click)="changeOrder(question.guid, question.order - 1)">
                                        <ion-icon class="bp-arrow-top-fill" name="topArrow"></ion-icon>
                                    </ion-button>
                                </ion-col>
                                <ion-col size="12">
                                    <ion-button mode="ios" (click)="changeOrder(question.guid, question.order + 1)">
                                        <ion-icon class="bp-arrow-bottom-fill" name="btArrow"></ion-icon>
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                        </div>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="question.expanded">
                <ion-col size="12">
                    <ion-item *ngIf="groupsSelectItems && groupsSelectItems.length > 0">
                        <ion-label position="stacked"> {{ "manageVersion.groupSelection" | translate }} * </ion-label>                        <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [value]="question.groupGuid" (ionChange)="groupChanged($event)">
                            <ion-select-option *ngFor="let item of groupsSelectItems" [value]="item.id">
                                {{ item.name }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col size="12" size-md="8">
                    <ion-item>
                        <ion-label position="stacked">{{ "manageVersion.questionTitle" | translate }} *</ion-label>
                        <ion-input type="text" [placeholder]="'manageVersion.questionTitle' | translate" [(ngModel)]="question.globalizationConfig[language].title"></ion-input>
                    </ion-item>
                </ion-col>
                <ion-col size="12" size-md="4">
                    <ion-item>
                        <ion-label position="stacked"> {{ "manageVersion.questionType" | translate }} * </ion-label>
                        <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [(ngModel)]="question.typeConfig.type" (ionChange)="clearOnTypeChange()">
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Text].enabled" [value]="QuestionType.Text">
                                {{ "manageVersion.text" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Title].enabled" [value]="QuestionType.Title">
                                {{ "manageVersion.title" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Description].enabled" [value]="QuestionType.Description">
                                {{ "manageVersion.description" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Boolean].enabled" [value]="QuestionType.Boolean">
                                {{ "manageVersion.boolean" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Slider].enabled" [value]="QuestionType.Slider">
                                {{ "manageVersion.slider" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Selection].enabled" [value]="QuestionType.Selection">
                                {{ "manageVersion.selection" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.MultiSelection].enabled" [value]="QuestionType.MultiSelection">
                                {{ "manageVersion.multiSelection" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Date].enabled" [value]="QuestionType.Date">
                                {{ "manageVersion.date" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Deadline].enabled" [value]="QuestionType.Deadline">
                                {{ "manageVersion.deadline" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.InitialDeadline].enabled" [value]="QuestionType.InitialDeadline">
                                {{ "manageVersion.initialDeadline" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Number].enabled" [value]="QuestionType.Number">
                                {{ "manageVersion.number" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Weight].enabled" [value]="QuestionType.Weight">
                                {{ "manageVersion.weight" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="questionsTypeAvailable[QuestionType.Calculate].enabled" [value]="QuestionType.Calculate">
                                {{ "manageVersion.calculate" | translate }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                    <ion-item *ngIf="question.typeConfig.type === QuestionType.Slider">
                        <ion-label position="stacked"> {{ "manageVersion.questionViewType" | translate }} * </ion-label>
                        <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [(ngModel)]="question.viewType" (ionChange)="clearOnViewTypeChange($event)">
                            <ion-select-option [value]="QuestionViewType.Left">
                                {{ "manageVersion.questionFormula.leftView" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionViewType.Top">
                                {{ "manageVersion.questionFormula.topView" | translate }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                    <ion-item *ngIf="question.typeConfig.type === QuestionType.Calculate">
                        <ion-label position="stacked"> {{ "manageVersion.questionFormula" | translate }} * </ion-label>
                        <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [(ngModel)]="question.formula" (ionChange)="clearOnTypeChange()">
                            <ion-select-option [value]="QuestionFormulaType.Sum">
                                {{ "manageVersion.questionFormula.sum" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionFormulaType.Average">
                                {{ "manageVersion.questionFormula.average" | translate }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col size="12">
                    <ion-item>
                        <ion-label position="stacked">{{ "manageVersion.questionReportColumn" | translate }}* </ion-label>
                        <ion-input type="text" [placeholder]="'manageVersion.questionReportColumn' | translate" [(ngModel)]="question.reportColumn"></ion-input>
                    </ion-item>
                </ion-col>
                <ion-col size="12">
                    <ion-item>
                        <ion-label position="stacked">
                            <h2>{{ "manageVersion.questionInstructions" | translate }}</h2>
                        </ion-label>
                        <ion-textarea
                            [placeholder]="'manageVersion.questionInstructions' | translate"
                            [(ngModel)]="question.globalizationConfig[language].instructions"
                        ></ion-textarea>
                    </ion-item>
                </ion-col>

                <ng-container *ngIf="question.typeConfig.type !== QuestionType.Slider">
                    <ion-col size="12" size-lg="9">
                        <ion-item>
                            <ion-label position="stacked"> {{ "manageVersion.answerPlaceholder" | translate }} * </ion-label>
                            <ion-input
                                type="text"
                                [placeholder]="'manageVersion.answerPlaceholder' | translate"
                                [(ngModel)]="question.globalizationConfig[language].placeholder"
                            ></ion-input>
                        </ion-item>
                    </ion-col>
                </ng-container>

                <ng-container *ngIf="question.typeConfig.type === QuestionType.Slider"> </ng-container>

                <ion-col size="12" size-lg="3" align-self-end>
                    <ion-item lines="none">
                        <ion-label class="ion-text-wrap">
                            {{ "generic.required" | translate }}
                        </ion-label>
                        <ion-checkbox custom-checkbox slot="start" mode="ios" [(ngModel)]="question.required"></ion-checkbox>
                    </ion-item>
                </ion-col>

                <ng-container *ngIf="question.typeConfig.type === QuestionType.Boolean">
                    <ion-col size="12" size-lg="12">
                        <ion-item>
                            <ion-label position="stacked">
                                {{ "manageVersion.questionTypeConfigLabel" | translate }}
                            </ion-label>                            <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [value]="question.typeConfig.id || 0" (ionChange)="onChangeQuestionTypeConfig($event, QuestionType.Boolean)">
                                <ion-select-option value="0">
                                    {{ "Nova" }}
                                </ion-select-option>
                                <ion-select-option
                                    *ngFor="let config of questionTypeConfigs | filter: 'type' : QuestionType.Boolean"
                                    [value]="config.id || 0"
                                >
                                    {{ config.name }}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12" size-sm="12" *ngIf="!question.typeConfig.id">
                        {{ question?.typeConfig | json }}
                        <ion-item>
                            <ion-label position="stacked"> {{ "configRange.Name" | translate }}* </ion-label>
                            <ion-input [placeholder]="'configRange.Name' | translate" [(ngModel)]="question.typeConfig.name" [disabled]="question.typeConfig.id"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12" size-sm="12">
                        <ion-button color="secondary" (click)="configureBooleanValues(question.typeConfig)" [disabled]="!question?.typeConfig?.name">
                            {{ "generic.valueConfig" | translate }}
                        </ion-button>
                    </ion-col>
                </ng-container>

                <ng-container *ngIf="question.typeConfig.type === QuestionType.Slider">
                    <ion-col size="12" size-lg="12">
                        <ion-item>
                            <ion-label position="stacked">
                                {{ "manageVersion.questionTypeConfigLabel" | translate }}
                            </ion-label>                            <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [value]="question.typeConfig.id || 0" (ionChange)="onChangeQuestionTypeConfig($event, QuestionType.Slider)">
                                <ion-select-option value="0"> Nova </ion-select-option>
                                <ion-select-option
                                    *ngFor="let config of questionTypeConfigs | filter: 'type' : QuestionType.Slider"
                                    [value]="config.id || 0"
                                >
                                    {{ config.name }}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col size-md="6" *ngIf="!question.typeConfig.id">
                        <ion-item>
                            <ion-label position="stacked"> {{ "configRange.Name" | translate }}* </ion-label>
                            <ion-input [placeholder]="'configRange.Name' | translate" [(ngModel)]="question.typeConfig.name"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size-md="6" *ngIf="!question.typeConfig.id">
                        <ion-item>
                            <ion-label position="stacked"> {{ "configRange.valuesAmount" | translate }} (2 ~ 6)* </ion-label>
                            <ion-input
                                type="number"
                                min="2"
                                max="6"
                                [placeholder]="'configRange.valuesAmount' | translate"
                                [(ngModel)]="question.typeConfig.valuesAmount"
                            ></ion-input>
                        </ion-item>
                    </ion-col>

                    <ion-button
                        color="primary"
                        [disabled]="isValidAmount(question.typeConfig.valuesAmount) === null || !question.typeConfig.name"
                        (click)="configureValuesRule(question.typeConfig)"
                    >
                        {{ "generic.valueConfig" | translate }}
                    </ion-button>
                </ng-container>

                <ion-col size="12">
                    <ion-item>
                        <ion-label position="stacked"> {{ "manageVersion.questionTypeForCalibration" | translate }} * </ion-label>
                        <ion-select [placeholder]="'generic.selectPlaceholder' | translate" [(ngModel)]="question.type" (ionCancel)="clearQuestionType()">
                            <ion-select-option [value]="QuestionConfigType.Goals">
                                {{ "manageVersion.QuestionConfigType.Goals" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.Comments">
                                {{ "manageVersion.QuestionConfigType.Comments" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.PrinciplesFinalGrade">
                                {{ "manageVersion.QuestionConfigType.PrinciplesFinalGrade" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.GoalsFinalGrade">
                                {{ "manageVersion.QuestionConfigType.GoalsFinalGrade" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.FinalGrade">
                                {{ "manageVersion.QuestionConfigType.FinalGrade" | translate }}
                            </ion-select-option>
                            <ion-select-option *ngIf="potentialTypeConfigEnabled" [value]="QuestionConfigType.Potential">
                                {{ "manageVersion.QuestionConfigType.Potential" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.QualitativeAnalisys">
                                {{ "manageVersion.QuestionConfigType.QualitativeAnalisys" | translate }}
                            </ion-select-option>
                            <ion-select-option [value]="QuestionConfigType.FinalConceptOfLeadership">
                                {{ "manageVersion.QuestionConfigType.FinalConceptOfLeadership" | translate }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-list>
    </div>

    <ng-container *ngIf="question.expanded && (question.typeConfig.type === QuestionType.Selection || question.typeConfig.type === QuestionType.MultiSelection)">
        <div padding class="form-setup-body-content">
            <ion-list mode="ios" lines="full">
                <ion-row llrm>
                    <ion-col size="12" *ngFor="let value of question.typeConfig.possibleValuesGlobalized[language]; let index = index; trackBy: valueTrackBy">
                        <div class="with-right-option">
                            <ion-item>
                                <ion-label position="stacked"> {{ "generic.option" | translate }} {{ index + 1 }} </ion-label>
                                <ion-textarea
                                    class="options-type-text-area"
                                    [maxlength]="ionSelectTextAreaMaxLenght"
                                    [(ngModel)]="question.typeConfig.possibleValuesGlobalized[language][index]"
                                ></ion-textarea>
                                <span
                                    class="counter"
                                    [ngClass]="{ 'counter-alert': question.typeConfig.possibleValuesGlobalized[language][index].length > ionSelectTextAreaMaxLenght }"
                                    >{{ question.typeConfig.possibleValuesGlobalized[language][index].length }} /{{ ionSelectTextAreaMaxLenght }}
                                    {{ "generic.characters" | translate | lowercase }}</span
                                >
                            </ion-item>
                            <div class="right">
                                <ion-button fill="clear" mode="ios" color="danger" align-self-end (click)="removePossibleValue(question, index)">
                                    <ion-icon class="bp-delete" name="delete"></ion-icon>
                                </ion-button>
                            </div>
                        </div>
                    </ion-col>
                    <ion-col size="12">
                        <ion-button fill="clear" mode="ios" color="primary" add-more (click)="addPossibleValue(question)">
                            + {{ "manageVersion.addOption" | translate | uppercase }}
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-list>
        </div>
    </ng-container>

    <ng-container
        *ngIf="
            question.expanded &&
            (question.typeConfig.type === QuestionType.Text || question.typeConfig.type === QuestionType.Title || question.typeConfig.type === QuestionType.Description)
        "
    >
        <div padding class="form-setup-body-content">
            <ion-list mode="ios" lines="full">
                <ion-row llrm>
                    <ion-col size="12">
                        <ion-item>
                            <ion-label position="stacked">
                                {{ "manageVersion.maxCharacter" | translate }}
                            </ion-label>
                            <ion-input type="text" placeholder="300" [(ngModel)]="question.typeConfig.max"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-list>
        </div>
    </ng-container>

    <ng-container *ngIf="question.expanded && question.typeConfig.type === QuestionType.Calculate">
        <div padding class="form-setup-body-content">
            <ion-list mode="ios" lines="full">
                <ion-row llrm>
                    <ion-col size="12" size-lg="3" align-self-end>
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                {{ "generic.showCalculate" | translate }}
                            </ion-label>
                            <ion-checkbox custom-checkbox slot="start" mode="ios" [(ngModel)]="question.typeConfig.showQuestion"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12" size-lg="3" align-self-end *ngIf="question.typeConfig.showQuestion">
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                {{ "generic.showLabel" | translate }}
                            </ion-label>
                            <ion-checkbox custom-checkbox slot="start" mode="ios" [(ngModel)]="question.typeConfig.showCalculateLabel"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12" size-lg="3" align-self-end *ngIf="question.typeConfig.showQuestion">
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                {{ "generic.showQuestionName" | translate }}
                            </ion-label>
                            <ion-checkbox custom-checkbox slot="start" mode="ios" [(ngModel)]="question.typeConfig.showQuestionName"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12">
                        <ion-item>
                            <ion-label position="stacked"> {{ "manageVersion.selectRelatedQuestions" | translate }} * </ion-label>
                            <ion-select
                                [attr.disabled]="relatedQuestions?.length === 0"
                                [placeholder]="'generic.selectPlaceholder' | translate"
                                [(ngModel)]="selectedRelatedQuestions"
                                multiple="true"
                            >
                                <ion-select-option
                                    *ngFor="let relatedQuestion of relatedQuestions; let index = index; trackBy: valueTrackBy"
                                    [value]="{ parentQuestionId: question.id, questionId: relatedQuestion.id }"
                                >
                                    {{ relatedQuestion.globalizationConfig[language].title }}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>

                        <ion-button fill="clear" mode="ios" color="primary" add-more [disabled]="!this.selectedRelatedQuestions" (click)="handleSelectedRelatedQuestion()">
                            + {{ "manageVersion.addQuestion" | translate | uppercase }}
                        </ion-button>
                    </ion-col>

                    <ion-col size="12">
                        <span class="list-question-title">{{ "manageVersion.relatedQuestions.title" | translate }}</span>
                    </ion-col>

                    <ng-container *ngIf="question?.relatedQuestions?.length; else EmptyRelatedQuestions">
                        <ion-col size="12" *ngFor="let relatedQuestion of question.relatedQuestions; let index = index; trackBy: valueTrackBy">
                            <div class="with-right-option">
                                <ion-item>
                                    <ion-label class="related-question-name">
                                        {{ relatedQuestionsMappedById[relatedQuestion.questionId]?.globalizationConfig[language]?.title }}
                                    </ion-label>
                                </ion-item>
                                <div class="right">
                                    <ion-button fill="clear" mode="ios" color="danger" align-self-end (click)="removeRelatedQuestion(relatedQuestion.questionId)">
                                        <ion-icon class="bp-delete" name="delete"></ion-icon>
                                    </ion-button>
                                </div>
                            </div>
                        </ion-col>
                    </ng-container>

                    <ng-template #EmptyRelatedQuestions>
                        <ion-col size="12">
                            <div class="with-right-option">
                                <ion-item>
                                    <ion-label class="related-question-name">
                                        {{ "manageVersion.relatedQuestions.empty" | translate }}
                                    </ion-label>
                                </ion-item>
                            </div>
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-list>
        </div>
    </ng-container>
</div>
